import { createActionThunk } from "redux-thunk-actions";
import {
  getStarted,
  getFailed,
  getEnded,
  getSucceeded,
  BODY_MAP_INITIALIZATION,
  GET_BODY_PARTS,
  GET_BODY_SYMPTOM,
} from "./constant";

import {
  getBodyPartsService,
  getBodySymptomService,
} from "../services/BodyService";
// import { getUser } from "../services/UserService";

// const bodyInitialization = createActionThunk(BODY_MAP_INITIALIZATION);
const bodyInitialization = () => {
  return (dispatch) => {
    dispatch({
      type: getStarted(BODY_MAP_INITIALIZATION),
    });
  };
};
const getBodyParts = createActionThunk(GET_BODY_PARTS, async (id) => {
  let bodyParts = await getBodyPartsService(id);
  return { bodyParts };
});
const doneClicked = createActionThunk(
  GET_BODY_SYMPTOM,
  async (bodyPart, symptomId, location = false) => {
    let symptom = await getBodySymptomService(bodyPart, symptomId, location);
    return { symptom };
  }
);

export default {
  bodyInitialization,
  getBodyParts,
  doneClicked,
};



// WEBPACK FOOTER //
// ./src/actions/bodyMapActions.js